import React, { useState } from 'react';
import {
  FormControl,
  Box,
  Input,
  Flex,
  Icon,
  Text,
  Image,
  Button,
  IconButton,
  Heading,
  Center,
} from '@chakra-ui/react';
import styled from 'styled-components';
import { SearchIcon } from '@chakra-ui/icons';
import { MdCheck, MdClose, MdGamepad } from 'react-icons/md';
import { useSearchBoardGame } from '../hooks/useSearchBoardGame';

const Modal = styled.div`
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100dvw;
  height: 100dvh;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;
type SearchModalProps = {
  isExist: (boardGameId: string) => boolean;
  onClose: () => void;
  onRegister: (boardGameId: string) => void;
};

const SearchModal = ({ isExist, onClose, onRegister }: SearchModalProps) => {
  const { isFetched, isLoading, searchedBoardGameList, searchBoardGame } =
    useSearchBoardGame();
  const [selectedBoardGame, setSelectedBoardGame] = useState<string>();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inpVal = e.target.value;
    searchBoardGame(inpVal);
  };

  return (
    <Modal>
      <Flex
        flexDir="column"
        bg="white"
        borderRadius="10px"
        flex="1"
        minH="600px"
      >
        <Flex
          mt="24px"
          mb="18px"
          py="12px"
          zIndex={8}
          alignSelf="stretch"
          justifyContent="space-between"
        >
          <IconButton
            opacity={0}
            isActive={false}
            disabled
            borderRadius="50%"
            boxSize="24px"
            variant="outline"
            aria-label="My"
          />
          <Heading
            as="h3"
            fontSize="18px"
            size="lg"
            lineHeight="tall"
            textAlign="center"
          >
            보드게임 검색
          </Heading>
          <IconButton
            onClick={onClose}
            borderRadius="50%"
            boxSize="24px"
            border="none"
            variant="outline"
            aria-label="close"
            icon={<Icon as={MdClose} />}
          />
        </Flex>
        <Flex
          width="100%"
          px="24px"
          justify="space-between"
          alignItems="center"
        >
          <FormControl w="100%" mr="16px">
            <Box display="flex" gap={2} my={3}>
              <Input
                placeholder="보드게임 이름 검색"
                p="16px"
                fontSize="14px"
                borderRadius="8px"
                variant="outline"
                type="text"
                onChange={handleChange}
              />
            </Box>
          </FormControl>
          <SearchIcon />
        </Flex>
        <Flex
          flexDir="column"
          mt="18px"
          px="24px"
          flex="1"
          overflowY="scroll"
          maxHeight="366px"
        >
          {!isFetched && !isLoading && (
            <Center flex="1">
              <Text>보드게임을 검색해 주세요</Text>
            </Center>
          )}
          {isLoading && (
            <Center flex="1">
              <Text>검색중입니다...</Text>
            </Center>
          )}
          {!isLoading && isFetched && searchedBoardGameList.length === 0 && (
            <Center flex="1">
              <Text>검색한 보드게임이 없어요 :(</Text>
            </Center>
          )}
          {searchedBoardGameList.map((boardGame) => (
            <Flex
              alignItems="center"
              key={boardGame.id}
              gap="4px"
              py="10px"
              px="14px"
              width="100%"
              onClick={() => setSelectedBoardGame(boardGame.id)}
              borderRadius="8px"
              borderWidth="2px"
              borderColor={
                selectedBoardGame === boardGame.id ? '#D84E46' : 'transparent'
              }
            >
              <Image
                border="2px solid #515151"
                borderRadius="8px"
                src={boardGame.thumbnail}
                width="50px"
                height="50px"
                minW="50px"
                minH="50px"
              />
              <Flex
                flexDir="column"
                alignItems="start"
                width="100%"
                fontWeight="semibold"
                fontSize="12px"
                ml="12px"
                color="#383838"
              >
                {isExist(boardGame.id) && (
                  <Flex
                    alignItems="center"
                    color="#D84E46"
                    fontWeight="extrabold"
                  >
                    <Icon as={MdGamepad} boxSize="8px" />
                    <Text fontSize="7px" ml="1px">
                      모임 소유
                    </Text>
                  </Flex>
                )}
                <Text fontSize="12px">
                  {boardGame.koreanName || boardGame.name}
                </Text>
              </Flex>
              {selectedBoardGame === boardGame.id && (
                <Icon color="#D84E46" as={MdCheck} />
              )}
            </Flex>
          ))}
        </Flex>
        <Button
          mt="18px"
          mb="24px"
          mx="24px"
          borderRadius="40px"
          bgColor={selectedBoardGame ? '#D84E46' : '#F0F0F0'}
          color={selectedBoardGame ? 'white' : '#9E9E9E'}
          _active={{
            bgColor: selectedBoardGame ? '#FFE5E4' : '#AB170F',
          }}
          _hover={{
            bgColor: selectedBoardGame ? '#FFE5E4' : '#AB170F',
          }}
          onClick={() => selectedBoardGame && onRegister(selectedBoardGame)}
        >
          등록
        </Button>
      </Flex>
    </Modal>
  );
};

export default SearchModal;
